<style>
</style>

<script lang="ts">
  import Banner from '../components/Banner.svelte'
  import DonationContactBtn from '../components/Donation_Contact_Btn.svelte'
  import GrowingFamily from '../components/Growing_Family.svelte'
  import LibraryPlatform from '../components/Library_Platform.svelte'
  import Partners from '../components/Partners.svelte'
  import SubscribeNewsletter from '../components/Subscribe_Newsletter.svelte'
  import { Slugs } from '../config/slugs'

  export const slug = Slugs.Donation
  let isBannerLoaded = false
  function setLoadedBanners() {
    isBannerLoaded = true
  }
</script>

<section>
  <Banner on:bannerLoaded={setLoadedBanners} {slug} />
  {#if isBannerLoaded}
    <DonationContactBtn />
    <LibraryPlatform />
    <GrowingFamily />
    <SubscribeNewsletter />
    <Partners />
  {/if}
</section>
